export class AuthModel {
  jwToken: string;
  refreshToken: string;
  isSurveyTaken?: boolean;
  setAuth(auth: any) {
    this.jwToken = auth.jwToken;
    this.refreshToken = auth.refreshToken;
  }
}
